module.exports = __webpack_public_path__ + "static/img/fefco203_2.75bd5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco203_2.png
// module id = vErR
// module chunks = 0